// hooks/usePagination.js
import { useState, useMemo } from "react";

export const usePagination = (items, itemsPerPage = 30) => {
  const [currentPage, setCurrentPage] = useState(1);

  const paginatedItems = useMemo(() => {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return items.slice(indexOfFirstItem, indexOfLastItem);
  }, [items, currentPage, itemsPerPage]);

  const totalPages = Math.ceil(items.length / itemsPerPage);

  // Resetear a página 1 cuando cambian los items
  const resetPage = () => setCurrentPage(1);

  return {
    currentPage,
    setCurrentPage,
    paginatedItems,
    totalPages,
    itemsPerPage,
    resetPage,
  };
};
